<template>
  <div>
    <el-dialog title="服务监控" :visible.sync="visible" class="large-dialog" :before-close="close">
      <div class="font-bold text-20px">连接列表</div>
      <div class="h-[calc(100%-40px)]">
        <el-table
          class="mt-20px"
          :data="surveillanceData"
          v-loading="surveillanceLoading"
          highlight-current-row
          row-key="id"
          border
          height="100%"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
        >
          <el-table-column
            prop="engineId"
            label="引擎ID"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="clients"
            label="客户端"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="clusterId"
            label="所属集群节点"
            sortable
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="maxTimeout"
            label="超时设置(ms)"
            sortable
            min-width="60px"
          ></el-table-column>
          <el-table-column prop="status" label="状态" sortable min-width="50px"></el-table-column>
          <el-table-column prop="type" label="传输类型" sortable min-width="50px"></el-table-column>
          <el-table-column
            prop="trueName"
            label="用户名称"
            sortable
            min-width="50px"
          ></el-table-column>
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="{ row }">
              <a href="javascript:;" @click="forceTerminate(row)" class="text-blue-600">强制终止</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import CloudProxyService from '../../services/CloudProxyService'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      surveillanceData: [],
      surveillanceLoading: false,
      timer: null,
    }
  },
  async created() {
    this.surveillanceLoading = true
    this.surveillanceData = await this.getConnectionList()
    this.surveillanceLoading = false
    // 开启定时器实时刷新列表
    this.timer = setInterval(async () => {
      this.surveillanceData = await this.getConnectionList()
    }, 2000)
  },
  beforeDestroy() {
    clearInterval(this.timer) // 组件销毁前清除定时器
  },
  methods: {
    // 强制终止连接
    async forceTerminate(row) {
      const [err, res] = await CloudProxyService.forceTerminate({
        id: row.engineId,
      })
      console.log(res, 11111111)
      if (!err && res && res.message === 'OK') {
        this.$message.success('终止成功')
        this.surveillanceData = await this.getConnectionList()
      } else {
        this.$message.error('终止失败')
      }
    },
    // 获取连接列表
    async getConnectionList(engineIds) {
      const ipObj = {}
      // 获取客户端的ip
      const [error, result] = await CloudProxyService.getIP({ t: dayjs().valueOf() })
      if (!error) {
        const resData = result
        _.forIn(resData, (v, k) => {
          ipObj[k] = v.ip.split('::ffff:')[1]
        })
      }
      const resArr = []
      const [err, res] = await CloudProxyService.getNodeConnectionList({ id: 'all' })
      if (!err && res && res.data) {
        const resData = res.data
        // 格式化数据
        _.forEach(resData, (v) => {
          v.clients = _.keys(v.clients)[0]
          v.clients && (v.clients = `${v.clients}@${ipObj[v.clients]}`)
          resArr.push(v)
        })
      }
      return resArr
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style></style>
